import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const RecipesWrap = styled.section`
  display: flex;
  justify-content: center;
  max-width: 1440px;
  margin: 122px auto 0;
  @media (max-width: 769px) {
    flex-direction: column;
    margin-top: 57px;
  }
`;

export const FirstHalf = styled.div`
  max-width: 520px;
  width: 100%;
  height: 1080px;
  display: flex;
  position: relative;
  @media (max-width: 769px) {
    height: 680px;
    margin: 0 auto;
  }
`;

export const SecondHalf = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 550px;
  width: 100%;
  margin-left: 9.028%;
  margin-top: 123px;
  @media (max-width: 769px) {
    margin-left: auto;
    margin-right: auto;
    margin-top: 1px;
  }
`;

export const Title = styled.h2`
  font-size: 36px;
  line-height: 42px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  margin-bottom: 10px;
  @media (max-width: 769px) {
    max-width: 370px;
  }
`;

export const Heading = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin: 20px 0 0;
`;
export const Text = styled.p`
  line-height: 1.7;
  @media (min-width: 769px) {
    font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : `16px`)};
    line-height: ${(props) => (props.fontSize ? `1.5` : `1.65`)};
  }
  max-width: ${(props) => (props.width ? `${props.width}px` : "initial")};
  color: ${(props) => (props.color === "grayDark" ? colors.GREY_DARK : colors.GREY_SEMIDARK)};
  margin: 0;
  ${(props) =>
    props.color === "grayDark"
      ? `
      font-family: ${fonts.latoBold};   
    `
      : `
       + p {
    margin-top: 22px;
  }
      
`};
`;
export const Link = styled.a`
  color: ${colors.RED};
  text-decoration: ${(props) => (props.noUnderline ? "none" : "underline")};
`;
export const Item = styled.li`
  position: relative;
  padding-left: 26px;
  @media (min-width: 769px) {
    padding-left: 28px;
  }
  & + li {
    margin-top: 20px;
  }
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 13px;
    height: 2px;
    width: 16px;
    background: ${colors.GREY_DARK};
    @media (min-width: 769px) {
      top: 13px;
      width: 18px;
    }
  }
`;
export const List = styled.ul`
  list-style: none;
  margin: 19px 0 0;
  padding: 0;
  color: ${colors.GREY_SEMIDARK};
  @media (min-width: 769px) {
    font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : `16px`)};
  }
`;
